CNT.ngModule.constant('loginAppConstant', {

	
});
